/* ============================================================
   AXION // SPECIFICATION — Layer 1 engine
   Live scroll coordinate readout + section counter for the
   instrument frame. Desktop-only (frame is hidden < 900px).
   Cheap: one rAF-throttled scroll handler + one IntersectionObserver.
   (Layer 2 — the Blueprint reveal — lives in axion-blueprint.js)
   ============================================================ */
(function () {
  'use strict';
  if (window.matchMedia && window.matchMedia('(max-width: 900px)').matches) return;

  var coord = document.getElementById('ax-spec-coord');
  var section = document.getElementById('ax-spec-section');
  if (!coord && !section) return;

  function pad(n) { return ('0000' + Math.max(0, Math.round(n))).slice(-4); }

  var ticking = false;
  function read() {
    var max = document.documentElement.scrollHeight - window.innerHeight;
    if (coord) coord.textContent = 'Y ' + pad(window.scrollY) + ' / ' + pad(max);
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; (window.requestAnimationFrame || setTimeout)(read); }
  }, { passive: true });
  read();

  /* section counter — "SHEET 03 / 08" as you pass each section */
  if (section && 'IntersectionObserver' in window) {
    var secs = document.querySelectorAll('#main .shopify-section, main > .shopify-section, main > section');
    var total = secs.length;
    if (total) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          var i = Array.prototype.indexOf.call(secs, e.target) + 1;
          section.innerHTML = '§ SHEET <b>' + pad(i).slice(-2) + '</b> / ' + pad(total).slice(-2);
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      secs.forEach(function (s) { io.observe(s); });
    }
  }
})();
